import request from '@/utils/request'

let RvisitApi = {

  /*回访列表*/
  list(data) {
    return request._post('/shop/plus.rvisit.rvisit.Index/index', data);
},
/*添加回访*/
add(data) {
    return request._post('/shop/plus.rvisit.rvisit.Index/add', data);
},
/*修改回访*/
edit(data) {
    return request._post('/shop/plus.rvisit.rvisit.Index/edit', data);
},
/*删除回访*/
del(data) {
    return request._post('/shop/plus.rvisit.rvisit.Index/del', data);
},
/*回访详情*/
detail(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/detail', data);
},
//获取
getDetail(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/getDetail', data);
},
//回访备注详情
detail_remark(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/detail_remark', data);
},//添加回访备注
add_remark(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/addRemark', data);
},
//修改回访备注
edit_remark(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/editRemark', data);
},
//删除回访备注
del_remark(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/delRemark', data);
},
//完结回访
finish_rvisit(data) {
  return request._post('/shop/plus.rvisit.rvisit.Index/finishRvisit', data);
},
saveSetting(data, errorback) {
  return request._post('/shop/plus.rvisit.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.rvisit.Setting/getSetting', data, errorback);
},
}
export default RvisitApi;



// WEBPACK FOOTER //
// ./src/api/rvisit.js